<script>

  /*
  |--------------------------------------------------------------------------
  | Dependency Definitions
  |--------------------------------------------------------------------------
  */

  import Vue from 'vue';

  import axios from 'axios';



  /*
  |--------------------------------------------------------------------------
  | Component Implementation
  |--------------------------------------------------------------------------
  */

  export default {
    name: 'customer-price',

    props: [
      'productID',
      'language'
    ],

    mounted() {
      this.fetchCustomers();
    },

    data() {
      return {
        customers: [],

        selectedCustomer: 'all',

        shownPrice: '- SEK'
      }
    },

    computed: {
      localizedPriceLabel() {
        if (this.language == 'sv') {
          return 'Pris';
        }

        return 'Price';
      },

      localizedSelectCustomerLabel() {
        if (this.language == 'sv') {
          return 'Välj kund';
        }

        return 'Select customer';
      },

      localizedCustomerPriceLabel() {
        if (this.language == 'sv') {
          return 'Kundpris';
        }

        return 'Customer price';
      },

      customersSelect() {
        var values = [];

        values.push({
          value: 'all',
          text: (this.language == 'sv') ? 'Alla' : 'All'
        });

        let sortedCustomers = this.customers.sort(function(a, b) {
          if (a.name > b.name) {
            return 1;
          } else if (a.name < b.name) {
            return -1;
          } else {
            return 0;
          }
        });

        for (var i = 0; i < sortedCustomers.length; i++) {
          let customer = sortedCustomers[i];

          values.push({
            value: customer.id,
            text: customer.name
          });
        }

        return values;
      },

      activeCustomer() {
        if (this.selectedCustomer == 'all') {
          return null;
        }

        var customer = null;

        for (var i = 0; i < this.customers.length; i++) {
          let currentCustomer = this.customers[i];

          if (currentCustomer.id == this.selectedCustomer) {
            customer = currentCustomer;
            break;
          }
        }

        return customer;
      }
    },

    methods: {
      fetchCustomers() {
        var self = this;

        axios.get('/api/v1/customers')
        .then(function (response) {
          self.customers = response.data.data;
        })
        .catch(function (error) {
          console.log("Error fetching customers: ", error);
        });
      },

      getCustomerPrice() {
        var self = this;

        var customerID = null;
        if (this.activeCustomer != null) {
          customerID = this.activeCustomer.id;
        }

        axios.post('/api/v1/products/customer/price', {
          lanugage: this.language,
          product_id: this.productID,
          customer_id: customerID
        })
        .then(function (response) {
          self.shownPrice = response.data.price;
        })
        .catch(function (error) {
          console.log("Error fetching price: ", error);
        });
      },
    }
  };
</script>

<template>
  <div>
    <h3>{{ localizedPriceLabel }}</h3>
    <p><strong>{{ localizedSelectCustomerLabel }}</strong></p>
    <select @change="getCustomerPrice" v-model="selectedCustomer">
      <option v-for="option in customersSelect" v-bind:value="option.value">
        {{ option.text }}
      </option>
    </select>
    <p class="customer-price">{{ localizedCustomerPriceLabel }}: {{ shownPrice }}</p>
  </div>
</template>
